import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs/operators';

export type ConfirmationDialogInput = {
  confirmButtonText?: string;
  cancelButtonText?: string;
  titleText?: string;
  descriptionText?: string;
}

export type ConfirmationDialogOutput = {
  confirmed: boolean;
}

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent {
  private static readonly defaultConfirmationDialogInput: ConfirmationDialogInput = {
    confirmButtonText: "Igen",
    cancelButtonText: "Nem"
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: ConfirmationDialogInput,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent, ConfirmationDialogOutput>
  ) {}

  protected onCancelButtonClick(): void {
    this.dialogRef.close({ confirmed: false });
  }

  protected onConfirmButtonClick(): void {
    this.dialogRef.close({ confirmed: true });
  }

  public static open(
    dialogService: MatDialog,
    data: Partial<ConfirmationDialogInput>

  ): MatDialogRef<ConfirmationDialogComponent, ConfirmationDialogOutput> {
    // Title or description must exist
    if(!data.titleText && !data.descriptionText) {
      throw new Error("Title text or description text must exist");
    }
    
    // If no confirmation button text or cancel button text provided, use the default one
    data.confirmButtonText ||= ConfirmationDialogComponent.defaultConfirmationDialogInput.confirmButtonText;
    data.cancelButtonText ||= ConfirmationDialogComponent.defaultConfirmationDialogInput.cancelButtonText;

    // Open the dialog
    const dialogRef: MatDialogRef<ConfirmationDialogComponent, ConfirmationDialogOutput> = 
    dialogService.open<ConfirmationDialogComponent, ConfirmationDialogInput, ConfirmationDialogOutput>(
      ConfirmationDialogComponent,
      {
        data: data,
        scrollStrategy: new NoopScrollStrategy(),
        hasBackdrop: true,
        backdropClass: 'invisible-backdrop',
        disableClose: true,
        minWidth: "300px",
        maxWidth: "90vw"
      }
    );

    // On the backdrop click close the dialog with "confirmed: false"
    dialogRef.backdropClick().pipe(take(1)).subscribe(
      () => {
        dialogRef.close({ confirmed: false });
      }
    );

    return dialogRef;
  }
}
